import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];

export default function ScopeRuleRow({ rule, onChange, onDelete }) {
  return (
    <tr>
      <td>
        <select
          className="form-select form-select-sm text-xs"
          value={rule.method}
          onChange={(e) => onChange({ ...rule, method: e.target.value })}
        >
          {METHODS.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </td>

      <td>
        <input
          className="form-control form-control-sm text-xs"
          value={rule.scope}
          onChange={(e) => onChange({ ...rule, scope: e.target.value })}
        />
      </td>

      <td className="text-center">
        <input
          type="checkbox"
          checked={rule.block}
          onChange={(e) => onChange({ ...rule, block: e.target.checked })}
        />
      </td>

      <td className="text-end">
        <span className="bg-dangerdd" onClick={onDelete}>
          <FontAwesomeIcon icon="trash" color="red"/>
        </span>
      </td>
    </tr>
  );
}
